import { createAction, createReducer } from '@reduxjs/toolkit'

const initialState = {
  isAuthenticated: false,
  isSuspended: false,
  account: null
}

export const authenticate = createAction('AUTHENTICATE')
export const setAccount = createAction('SET_ACCOUNT')
export const setSuspended = createAction('SET_SUSPENDED')

export default createReducer(initialState, builder => {
  builder
    .addCase(authenticate, state => {
      state.isAuthenticated = true
    })
    .addCase(setAccount, (state, action) => {
      state.account = action.payload
    })
    .addCase(setSuspended, state => {
      state.isSuspended = true
    })
})
